export const SECONDS_OF_TEN_MINUTE = 600;
